// noinspection JSUnusedGlobalSymbols,CommaExpressionJS,ES6ConvertVarToLetConst
import GoogleAds, {
  GoogleAdsId,
  GA4Id,
  CriteoPartnerID,
  FacebookId,
  BingId,
  KlaviyoId,
} from './utils/GoogleAds'

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import wrapWithProvider from './redux-provider'
// import NProgress from 'nprogress'

/**
 * Use one of the below
 * NOTE: comment out attribution part if in regular mode
 **/
// ** [Regular] Used to find Real User Experience (use for regular performance monitoring)
// import { onLCP, onINP, onCLS } from 'web-vitals'
// ** [Attribution] Used to find Real User Experience element causing the most problem (use to debug issues)
import { onLCP, onINP, onCLS, onFCP, onTTFB } from 'web-vitals/attribution'
import {
  TrackEvent,
  TrackUser,
  PersonalInfo,
  CheckTrackedUser,
  SendCriteoEvent,
} from './src/helpers/TrackingHelper'
import {
  readStoredConsent,
  prefsToConsentParams,
  REGULATED_REGIONS,
} from './src/helpers/consentMode'

// const initRudderStack = () => {
//   window.rudderanalytics.loadJS()
// }

const STORAGE_KEY = 'cookieConsent'
const DEFAULT_PREFS = { analytics: true, marketing: true, advertising: true }

const initScripts = () => {
  // console.log(`Init scripts [${!window.scriptsDidInit}], after ${(new Date().getTime() - window.started)} milliseconds`)
  if (window.scriptsDidInit) {
    return false
  }
  window.scriptsDidInit = true // flag to ensure script does not get added to DOM more than once.

  let prefs = DEFAULT_PREFS
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      prefs = JSON.parse(stored)
    } else {
      const match = document.cookie.match(new RegExp(`${STORAGE_KEY}=([^;]+)`))
      if (match) {
        prefs = JSON.parse(decodeURIComponent(match[1]))
      }
    }
  } catch (e) {
    console.warn('Error reading cookie prefs', e)
  }

  // initRudderStack()
  // Init Klavyio
  if (prefs.marketing) {
    addScript(`//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${KlaviyoId}`, () => {
      addKlaviyoFormsTracking()
    })
    addScript('//cdn.callrail.com/companies/267670386/7ad9f09f303977651ce0/12/swap.js')
  }

  if (prefs.analytics) {
    addScript(`//www.googletagmanager.com/gtag/js?id=${GA4Id}`)
    initCoreWebVitals()
  }
  // initGTM(window, 'dataLayer', 'GTM-K25RWJ')
  // addScript(`//www.googletagmanager.com/gtag/destination?id=${GoogleAdsId}&l=dataLayer&cx=c`)
  if (prefs.advertising) {
    initFacebookPixel(window, FacebookId)
    initBing(window, 'uetq', BingId)
    // if (window.tng) window.tng.runLoad()
    if (window.fbq) window.fbq.runLoad()
    initCriteo()
    setTimeout(CheckTrackedUser, 500)
    // addScript('//apis.google.com/js/platform.js?onload=renderBadge')
  }
}

const sendToGoogleAnalytics = ({ name, delta, value, id, attribution }) => {
  const eventParams = {
    // Built-in params:
    value: delta, // Use `delta` so the value can be summed.

    // Custom params with descriptive names:
    web_vitals_id: id, // Needed to aggregate events.
    web_vitals_value: value, // The metric value.
    web_vitals_delta: delta, // The delta between values.
    web_vitals_load_state: attribution?.loadState || '',
  }

  // NOTE: comment out if in regular mode
  switch (name) {
    case 'CLS':
      eventParams.web_vitals_debug_target = attribution?.largestShiftTarget
      break
    case 'INP':
      eventParams.web_vitals_debug_target = attribution?.interactionTarget
      eventParams.web_vitals_debug_interaction_type = attribution?.interactionType
      eventParams.web_vitals_input_delay = attribution?.inputDelay
      eventParams.web_vitals_processing_duration = attribution?.processingDuration
      eventParams.web_vitals_presentation_delay = attribution?.presentationDelay
      // console.log(`INP ${eventParams.web_vitals_value} Attribution Events`, attribution?.processedEventEntries.map(e => ({
      //   time: e.processingEnd - e.processingEnd,
      //   timeSinceStart: e.processingEnd - e.startTime,
      //   entryType: e.entryType,
      //   name: e.name,
      //   details: e
      // })))
      break
    case 'LCP':
      eventParams.web_vitals_debug_target = attribution?.element
      break
  }

  // Send the event to Google Analytics
  //
  // console.log(
  //   `[CoreWebVitals] ${name}: ${value} (+${delta}) <${eventParams.web_vitals_debug_target}>`,
  //   {
  //     location: window?.location?.pathname,
  //     attribution,
  //   }
  // )
  if (window.gtag) {
    window.gtag('event', name, eventParams)
  }
}

const initCoreWebVitals = () => {
  onCLS(sendToGoogleAnalytics)
  onINP(sendToGoogleAnalytics, { reportAllChanges: true })
  onLCP(sendToGoogleAnalytics)

  onFCP(sendToGoogleAnalytics)
  onTTFB(sendToGoogleAnalytics)
}

const addKlaviyoFormsTracking = () => {
  window.addEventListener('klaviyoForms', function (e) {
    /* Possible values for e.detail.type:
     * Read: https://help.klaviyo.com/hc/en-us/articles/115005077027
     * ```
    if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
      gtag('event', 'form_open', { form: 'Klaviyo form', form_id: e.detail.formId })
    }
    if (e.detail.type == 'submit') {
      gtag('event', 'form_submit', { form: 'Klaviyo form', form_id: e.detail.formId })
    }
    if (e.detail.type == 'stepSubmit') {
      gtag('event', 'form_step_submit', {
        form: 'Klaviyo form',
        step_name: e.detail.metaData.$step_name,
      })
    }
    if (e.detail.type == 'redirectedToUrl') {
      gtag('event', 'form_url_redirect', { form: 'Klaviyo form', form_id: e.detail.formId })
    }
    if (e.detail.type == 'close') {
      gtag('event', 'form_close', { form: 'Klaviyo form', form_id: e.detail.formId })
    } ```
    */
    if (e?.detail?.type == 'submit') {
      const formId = e?.detail?.formId
      const formTitle = e?.detail?.metaData?.$source
      const email = e?.detail?.metaData?.$email
      TrackUser(email, PersonalInfo({ ...e.detail, ...e?.detail?.metaData }))
      TrackEvent(
        'email_subscribe',
        {
          email,
          source: 'Klaviyo',
          formId,
          formTitle,
        },
        {
          klaviyoEventName: 'Email Subscribe',
          googleAdsConversion: GoogleAds.Conversions.email_subscribe,
          facebook: {
            fbEvent: 'Contact',
          }
        }
      )
    }
  })
}
const initScriptsOnIdle = () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => initScripts())
  } else {
    setTimeout(initScripts, 250) // Fallback if `requestIdleCallback` isn't supported
  }
}

const initScriptsOnEvent = () => {
  // console.log(`${event.type}, after ${(new Date().getTime() - window.started)} milliseconds`)
  initScriptsOnIdle()
  // ** remove specific event listener
  // event.currentTarget.removeEventListener(event.type, initScriptsOnEvent)
  unregisterListeners()
}
const getQueryString = () => {
  const item = window.sessionStorage.getItem('qs')
  if (!item) return {}
  try {
    const qs = JSON.parse(item)
    window.qs = qs
    return qs
  } catch {
    return {}
  }
}
const setQueryString = qs => {
  try {
    window.sessionStorage.setItem('qs', JSON.stringify(qs))
  } catch (e) {
    console.error('Failed to save query string to sessionStorage', e)
  }
  window.qs = qs
}
const addScriptExecutor = (doc, tag, src, onLoad) => {
  let head = doc.getElementsByTagName(tag)[0]
  let scrpt = doc.createElement(tag)
  scrpt.async = true
  scrpt.src = src
  if (onLoad) {
    scrpt.onload = scrpt.onreadystatechange = function () {
      let ready = this.readyState
      if (!ready || ready === 'loaded' || ready === 'complete') {
        onLoad()
        scrpt.onload = scrpt.onreadystatechange = null
      }
    }
  }
  head.parentNode.insertBefore(scrpt, head)
}
const addScript = (src, onLoad) => {
  addScriptExecutor(document, 'script', src, onLoad)
}
// const initGTM = (wnd, layer, id) => {
//   wnd[layer] = wnd[layer] || []
//   wnd[layer].push({
//     'gtm.start': new Date().getTime(),
//     event: 'gtm.js',
//   })
//   let dl = layer != 'dataLayer' ? '&l=' + layer : ''
//   addScript('//www.googletagmanager.com/gtm.js?id=' + id + dl)
// }

const initBing = (wnd, layer, id) => {
  wnd[layer] = window[layer] || []
  let onLoad = function () {
    let cnf = { ti: id, enableAutoSpaTracking: true }
    cnf.q = window[layer]
    window[layer] = new window.UET(cnf)
    window[layer].push('pageLoad')
  }
  addScript('//bat.bing.com/bat.js', onLoad)
}

const initFacebookPixel = (wnd, pixelId, fbqLayer = 'fbq') => {
  const fbq = wnd[fbqLayer]
  // Ensure the fbq layer is defined
  if (!wnd._fbq) {
    wnd._fbq = fbq
  }
  // Set up additional properties for fbq
  fbq.push = fbq
  fbq.version = '2.0'
  fbq.queue = []

  // Onload callback to initialize Facebook Pixel
  fbq('init', pixelId)
  fbq('track', 'PageView')
}

const initCriteo = () => {
  addScript(`//dynamic.criteo.com/js/ld/ld.js?a=${CriteoPartnerID}`)
}


export const shouldUpdateScroll = ({ routerProps, prevRouterProps, getSavedScrollPosition }) => {
  const { location } = routerProps

  console.log('[DEBUG] Should Update Scroll?', { hash: location.hash })
  if (location.hash) return false

  if (prevRouterProps && typeof getSavedScrollPosition === 'function') {
    const pos = getSavedScrollPosition(location) || [0, 0]
    console.log('[DEBUG] Update Scroll', { pos })
    return pos 
  }

  console.log('[DEBUG] Update Scroll', { pos: [0, 0] })
  return [0, 0]
}

export const onClientEntry = () => {
  console.log('Welcome to Gray & Sons!')
  if (typeof window !== 'undefined' && !window.__backNavListener) {
    window.__backNavListener = true
    window.__isBackNav = false
    window.addEventListener('popstate', () => {
      window.__isBackNav = true
    })
  }
  window.user = window.user || {} 
  window.dataLayer = window.dataLayer || []
  window._learnq = window._learnq || []
  window.criteo_q = window.criteo_q || []
  window.uetq = window.uetq || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = window.gtag || gtag

  // let tng = window.tng = (window.tng = window.tng || [])
  window.addScript = addScript
  const fbq = (window.fbq =
    window.fbq ||
    function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments)
      } else {
        (fbq.queue || (fbq.queue = [])).push(arguments)
      }
    })
  fbq.loaded = false
  fbq.queue = fbq.queue || []
  fbq.shouldLoad = false

  let deviceType = /iPad/.test(navigator.userAgent)
    ? 't'
    : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)
    ? 'm'
    : 'd'
  let initial_page = window.sessionStorage.getItem('initial_page')
  if (!initial_page) {
    window._initial_page = window.location.href
    window.sessionStorage.setItem('initial_page', window._initial_page)
  } else {
    window._initial_page = initial_page
    window._device_type = deviceType
  }

  // --- Google Consent Mode v2 ---
  const storedConsent = readStoredConsent()
  if (storedConsent) {
    // Returning visitor with confirmed prefs
    gtag('consent', 'default', prefsToConsentParams(storedConsent))
  } else {
    // New visitor — global default: grant all
    gtag('consent', 'default', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    })
    // Override for regulated regions: deny all + wait for banner
    gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 500,
      region: REGULATED_REGIONS,
    })
  }

  // Configure gtag with your GA4 and Google Ads IDs
  gtag('js', new Date())
  gtag('config', GA4Id)
  gtag('config', GoogleAdsId)
  //
  // gtag('config','G-LHPEQ813PL')
  // gtag('config','G-1S8B9HGMB3')
  // gtag('config','GT-WV8WQ69')

  fbq.runLoad = function () {}
  fbq.load = function () {
    if (fbq.loaded) return
    fbq.runLoad = fbq.load
    if (!window.scriptsDidInit) return
    fbq.loaded = true
    addScript('//connect.facebook.net/en_US/fbevents.js')
  }

  // tng.runLoad = function () {}
  // tng.load = function () {
  //   if (tng.loaded) return
  //   tng.runLoad = tng.load
  //   if (!window.scriptsDidInit) return
  //   tng.loaded = true
  //   addScript(
  //     '//cdn.tangiblee.com/integration/5.0/managed/www.grayandsons.com/revision_2/variation_original/tangiblee-bundle.min.js'
  //   )
  // }
  // window.renderBadge = function () {
  //   const el = document.getElementById('google-merchant-badge-container')
  //   if (!window.gapi || !el || el.__gmrbInit) return
  //   el.__gmrbInit = true
  //
  //   // --- CONSTANTS ---
  //   const CHIP_W = 255
  //   const CHIP_H = 68
  //
  //   // --- START: stable chip box => zero CLS, zero “dead zone” ---
  //   el.style.width = CHIP_W + 'px'
  //   el.style.height = CHIP_H + 'px'
  //   el.setAttribute('aria-hidden', 'true')
  //   el.classList.add('gmrb-collapsed', 'gmrb-clip') // collapsed: iframe not clickable, clipped to chip
  //
  //   // --- LOAD & RENDER BADGE ---
  //   window.gapi.load('ratingbadge', () => {
  //     window.gapi.ratingbadge.render(el, {
  //       merchant_id: 10751,
  //       position: 'LEFT_BOTTOM',
  //     })
  //
  //     // Wait for iframe, then reveal (opacity/transform only)
  //     const waitForIframe = () => {
  //       const f = el.querySelector('iframe')
  //       if (!f) return requestAnimationFrame(waitForIframe)
  //       el.classList.add('is-ready') // purely visual; does not change layout
  //
  //       // ResizeObserver on the iframe ONLY.
  //       // We resize host to iframe's size ONLY when expanded (post-interaction => no CLS).
  //       const ro = new ResizeObserver(() => {
  //         if (!el.classList.contains('gmrb-expanded')) return
  //         // const r = f.getBoundingClientRect()
  //         el.style.width = f.style.width //  Math.round(r.width) + 'px'
  //         el.style.height = f.style.height // Math.round(r.height) + 'px'
  //       })
  //       ro.observe(f)
  //
  //       // If Google swaps the iframe node, reobserve the new one
  //       const mo = new MutationObserver(() => {
  //         const nf = el.querySelector('iframe')
  //         if (nf && nf !== f) {
  //           ro.disconnect()
  //           ro.observe(nf)
  //         }
  //       })
  //       mo.observe(el, { childList: true })
  //
  //       // --- Expand / Collapse helpers ---
  //       const expand = () => {
  //         // allow iframe to be interactive and grow to its natural size
  //         el.classList.remove('gmrb-collapsed', 'gmrb-clip')
  //         el.classList.add('gmrb-expanded')
  //         el.setAttribute('aria-hidden', 'false')
  //
  //         // snap to current iframe size immediately
  //         const fi = el.querySelector('iframe')
  //         if (fi) {
  //           const r = fi.getBoundingClientRect()
  //           el.style.width = Math.round(r.width) + 'px'
  //           el.style.height = Math.round(r.height) + 'px'
  //         }
  //       }
  //
  //       const collapse = () => {
  //         // return to chip; no overlay above the chip height
  //         el.classList.remove('gmrb-expanded')
  //         el.classList.add('gmrb-collapsed', 'gmrb-clip')
  //         el.setAttribute('aria-hidden', 'true')
  //         el.style.width = CHIP_W + 'px'
  //         el.style.height = CHIP_H + 'px'
  //       }
  //
  //       // Interaction model:
  //       // While collapsed, the iframe doesn't receive input (pointer-events:none),
  //       // so we always catch the intent on the container reliably.
  //       el.addEventListener(
  //         'pointerdown',
  //         e => {
  //           if (el.classList.contains('gmrb-collapsed')) {
  //             expand()
  //             e.preventDefault()
  //             e.stopPropagation()
  //           }
  //         },
  //         { passive: true }
  //       )
  //
  //       // Click outside or ESC collapses back to chip
  //       document.addEventListener(
  //         'pointerdown',
  //         e => {
  //           if (!el.contains(e.target)) collapse()
  //         },
  //         { passive: true }
  //       )
  //       document.addEventListener('keydown', e => {
  //         if (e.key === 'Escape') collapse()
  //       })
  //     }
  //
  //     waitForIframe()
  //   })
  // }
}

const unregisterListeners = () => {
  window.removeEventListener('load', initScriptsOnEvent)
  document.removeEventListener('scroll', initScriptsOnEvent)
  document.removeEventListener('mousemove', initScriptsOnEvent)
  document.removeEventListener('touchstart', initScriptsOnEvent)
}

export const onInitialClientRender = () => {
  // console.log('Initial Render, document state:', document.readyState)
  // window.started = new Date().getTime()
  // document.addEventListener('DOMContentLoaded', () => {
  //   console.log(`DOMContentLoaded, after ${new Date().getTime() - window.started} milliseconds`)
  // })
  // window.addEventListener('load', () => {
  //   console.log(`Window Load, after ${new Date().getTime() - window.started} milliseconds`)
  // })
  if (document.readyState === 'complete') {
    initScriptsOnIdle()
  } else {
    window.addEventListener('load', initScriptsOnEvent)
    document.addEventListener('scroll', initScriptsOnEvent)
    document.addEventListener('mousemove', initScriptsOnEvent)
    document.addEventListener('touchstart', initScriptsOnEvent)
  }
}

export const onPreRouteUpdate = () => {
  // console.log('Route Update')
  if (!window.scriptsDidInit) {
    return false
  }
  // NProgress.start()
}
// On Route Update (it can accept location and prevLocation as arguments if you need them)
export const onRouteUpdate = () => {
  // console.log('Route Done')
  // NProgress.done()
  setTimeout(() => {
    if(window.location.hash) return
    if (window.__isBackNav) {
      window.__isBackNav = false
      return
    }
    scrollTo(0, 0)
  }, 100)
  const vars = getQueryString()
  if (location.search) {
    const query = location.search.substring(1)
    query.split('&').forEach(v => {
      const pair = v.split('=')
      if (pair.length > 1) {
        vars[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1])
      } else {
        vars[decodeURIComponent(pair[0])] = null
      }
    })
    setQueryString(vars)
  }
  window?._learnq?.push(['track', 'Viewed a Page', { url: location.href }])
  window?._learnq?.push(['track', 'Active on Site', { url: location.href }])
  window?.gtag('event', 'page_view', {
    page_title: window.document.title,
    page_location: location.href,
  })
  if (location.pathname === '/') {
    window?.gtag('event', 'home_view', {
      page_title: window.document.title,
      page_location: location,
    })
    SendCriteoEvent({ event: 'viewHome' })
  } else {
    SendCriteoEvent({ event: 'viewPage' })
  }
  // window?.rudderanalytics?.page()
  // ensure badge renders after SPA navigations once the placeholder is in the DOM
  // window?.renderBadge?.()
}
export const wrapRootElement = wrapWithProvider
